import { render } from "./mga-real-money-balance-page.vue?vue&type=template&id=ba967432&ts=true"
import script from "./mga-real-money-balance-page.ts?vue&type=script&lang=ts"
export * from "./mga-real-money-balance-page.ts?vue&type=script&lang=ts"

import "./mga-real-money-balance-page.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__